import report from '@alexistessier/report';

export default {
	report
};